var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgService3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 163,
    viewBox: "0 0 163 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    filter: "url(#filter0_f_744_14030)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 81.5,
    cy: 81.5001,
    r: 42.1299,
    fill: "#0065F2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.12 64.3702C104.262 64.3702 107.62 61.0123 107.62 56.8702C107.62 52.7281 104.262 49.3702 100.12 49.3702C95.9779 49.3702 92.62 52.7281 92.62 56.8702C92.62 61.0123 95.9779 64.3702 100.12 64.3702Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.12 64.3702C92.8836 64.3702 86.995 70.2588 86.995 77.4952V79.3702H113.37V77.4952C113.37 70.2588 107.356 64.3702 100.12 64.3702Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.87 68.1202C61.9766 68.1202 64.495 65.6018 64.495 62.4952C64.495 59.3886 61.9766 56.8702 58.87 56.8702C55.7634 56.8702 53.245 59.3886 53.245 62.4952C53.245 65.6018 55.7634 68.1202 58.87 68.1202Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.245 77.4952C68.245 72.3261 64.0391 68.1202 58.87 68.1202C53.7009 68.1202 49.37 72.3261 49.37 77.4952V79.3702H68.245V77.4952Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.995 68.1202H83.245V71.8702H71.995V68.1202Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.995 75.6202H83.245V79.3702H71.995V75.6202Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.37 85.2452H113.37V113.37H49.37V85.2452ZM85.3818 92.4889C85.3818 92.2525 85.6712 92.0608 86.0284 92.0608C86.3855 92.0608 86.675 92.2525 86.675 92.4889V95.4858H87.9682V105.761H86.675V108.33C86.675 108.566 86.3855 108.758 86.0284 108.758C85.6712 108.758 85.3818 108.566 85.3818 108.33V105.761H84.0886V95.4858H85.3818V92.4889ZM76.9759 90.3483C76.6187 90.3483 76.3293 90.54 76.3293 90.7765V93.7733H75.0361V104.048H76.3293V106.617C76.3293 106.854 76.6187 107.045 76.9759 107.045C77.333 107.045 77.6225 106.854 77.6225 106.617V104.048H78.9157V93.7733H77.6225V90.7765C77.6225 90.54 77.333 90.3483 76.9759 90.3483ZM94.4343 86.9233C94.4343 86.6868 94.7238 86.4952 95.0809 86.4952C95.4381 86.4952 95.7275 86.6868 95.7275 86.9233V89.9202H97.0207V100.195H95.7275V102.764C95.7275 103 95.4381 103.192 95.0809 103.192C94.7238 103.192 94.4343 103 94.4343 102.764V100.195H93.1411V89.9202H94.4343V86.9233ZM67.2768 98.9108H65.9836V109.186H67.2768V111.755C67.2768 111.991 67.5662 112.183 67.9234 112.183C68.2805 112.183 68.57 111.991 68.57 111.755V109.186H69.8632V98.9108H68.57V95.9139C68.57 95.6774 68.2805 95.4858 67.9234 95.4858C67.5662 95.4858 67.2768 95.6774 67.2768 95.9139V98.9108Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_744_14030",
    x: 0.903595,
    y: 0.903732,
    width: 161.193,
    height: 161.193,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.2332,
    result: "effect1_foregroundBlur_744_14030"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgService3);
export default __webpack_public_path__ + "static/media/service_3.fdffcd214d4e3fa29746e13d3fcc65e6.svg";
export { ForwardRef as ReactComponent };